module.exports = __webpack_public_path__ + "static/media/sport.2232eb45.svg";